module.exports = __webpack_public_path__ + "img/norway-infectious-diseases-male.8530f887.png";